// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"b9faa624","673":"17834401","767":"88b593b2"}[chunkId] + ".chunk.js";
};